// extracted by mini-css-extract-plugin
export default {"container":"animated_link-module__container--HQHU4","icon":"animated_link-module__icon--2IZy6","title":"animated_link-module__title--36nsi"};